import { store } from '../store'
import { isSessionExpired } from '../../utils/tokenRefresh'

const { dispatch } = store ?? {}

const dispatchNotificationState = (notificationState: { [key: string]: string | null }) => {
  // Suppress error notifications when session has expired to prevent
  // confusing error toasts alongside the session expired modal
  if (notificationState.type === 'failed' && isSessionExpired()) {
    return
  }
  
  dispatch.commonModel.updateNotificationState(notificationState)
}

export { dispatchNotificationState }
